import { useParams, useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import NewAffiliateForm from "../../components/affiliates/NewAffiliatesForm";

export default function NewAffiliate() {
    const { productId } = useParams<{ productId: string }>();
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/products/edit/${productId}?tab=affiliates`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Convidar Afiliado"
                description="Adicionar novo afiliado"
            />
            <PageBreadcrumb
                pageTitle="Convidar Afiliado"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewAffiliateForm
                    productId={productId}
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de afiliados
                        navigate(`/products/edit/${productId}?tab=affiliates`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar afiliado:", error);
                    }}
                />
            </div>
        </>
    );
}